import { TextInput } from 'components/_form-elements/TextInput/TextInput';
import { Button } from 'components/_universal/Button/Button';
import { DefaultText } from 'components/_universal/Typography.styled';
import styled, { css } from 'styled-components';

export const ProfilePageWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    width: 100%;
`;

export const ProfileImageWrapper = styled.div(
    ({ theme: { colors } }) => css`
        align-items: center;
        border-bottom: 1px solid ${colors.profileBorder};
        display: flex;
        flex-direction: column;
        margin-bottom: 26px;
        max-width: 728px;
        padding: 44px 0;
        position: relative;
        width: 100%;
    `,
);

export const ProfileImageInputWrapper = styled.div`
    height: 100px;
    position: relative;
    width: 100px;
`;

export const ProfileImageInput = styled.input`
    bottom: 0;
    cursor: pointer;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    width: 100%;
`;

export const ProfileImage = styled.img(
    ({ theme: { colors } }) =>
        css`
            border-radius: 100%;
            border: 5px solid ${colors.profileImageBorder};
            height: 100px;
            margin-bottom: 12px;
            width: 100px;
        `,
);

export const ProfileTitle = styled(DefaultText)(
    ({ theme: { colors, fontFamily, fontSizes, fontWeight } }) => css`
        color: ${colors.text};
        font-family: ${fontFamily.secondary};
        font-size: ${fontSizes.f20};
        font-weight: ${fontWeight.medium};
    `,
);

export const FormWrapper = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    max-width: 50%;
    width: 100%;
`;

export const StyledInput = styled(TextInput)``;

export const StyledButton = styled(Button)(
    ({ theme: { fontSizes } }) => css`
        align-self: flex-end;
        font-size: ${fontSizes.f12};
        margin-top: 16px;
        max-width: 141px;
    `,
);

export const StyledFormWrapper = styled.div`
    display: flex;
    gap: 140px;
    width: 100%;
`;

export const StyledFormInnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
`;

export const StyledDivider = styled.div(
    ({ theme: { colors } }) => css`
        background-color: ${colors.profileBorder};
        height: 1px;
        width: 100%;
        margin-bottom: 10px;
    `,
);

export const RemoveAvatarIconWrapper = styled.div`
    bottom: 0;
    position: absolute;
    right: 0;
`;
